import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const config = {
    position: 'top-right',
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
};

export default {
    ShowError(msg = '', outrasconfigs = {}) {
        toast.error(msg, {
            ...config,
            ...outrasconfigs,
        });
    },
    ShowSuccess(msg = '', outrasconfigs = {}) {
        toast.success(msg, {
            ...config,
            ...outrasconfigs,
        });
    },
    ShowWarning(msg = '', outrasconfigs = {}) {
        toast.warning(msg, {
            ...config,
            ...outrasconfigs,
        });
    },
    ShowInfo(msg = '', outrasconfigs = {}) {
        toast.info(msg, {
            ...config,
            ...outrasconfigs,
        });
    }
};
